import React from 'react';
import {
  FormModal,
  FormModalBody,
  FormModalSubmitMenu,
} from 'common/ui/themes/disona/modals';
import { KYC_REQUIRED_MODAL_ID } from 'common/constants/profile.constants';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import { kycStore } from 'common/stores/kyc.store';
import { kycService } from 'common/services/kyc.service';
import { S } from '../style';

export const KYCRequiredModalDisona = observer(() => {
  return (
    <FormModal
      title="KYC"
      ModalId={KYC_REQUIRED_MODAL_ID}
      onCloseCallback={() =>
        runInAction(() => {
          kycStore.handling403FromKycService = false;
        })
      }
    >
      <FormModalBody>
        <S.ContainerCentre>
          {kycStore.rejected || kycStore.handling403FromKycService ? (
            <>
              <S.Red> This functionality is disabled</S.Red>
              <S.Dimmer>Please contact customer support</S.Dimmer>
            </>
          ) : (
            <>
              <S.Bold>This functionality </S.Bold>
              <S.Dimmer>
                will be available only after passing KYC procedure
              </S.Dimmer>
            </>
          )}
          {kycStore.processing && (
            <S.Green>Your documents are being processed</S.Green>
          )}
        </S.ContainerCentre>
      </FormModalBody>
      <FormModalSubmitMenu
        saveButtonText="Start"
        saveButtonCallback={kycService.beginForcedKyc}
        saveButtonDisabled={
          !(
            (kycStore.needsInfo && !kycStore.handling403FromKycService) ||
            kycStore.handling403FromPaymentService
          )
        }
      />
    </FormModal>
  );
});
